module.exports = __webpack_public_path__ + "static/media/down-carat.775c3ea9.svg";